// extracted by mini-css-extract-plugin
export default {"sidebarMenu":"Sidebar_sidebarMenu__3pJzX","active":"Sidebar_active__XaedQ"};